export interface IconProps {
  size?: number;
  stroke?: string;
  className?: string;
  strokeWidth?: number,
}

const PlusIcon = ({
  size = 24,
  stroke = 'currentColor',
  strokeWidth = 2,
  className,
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke={stroke}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M5 12h14" />
    <path d="M12 5v14" />
  </svg>
);

export default PlusIcon;
